import styled from 'styled-components';
import { Modal } from '$gcomponents/reusables';

export const ModalWrapper = styled(Modal)`
  .content {
  }
`;
